import { __assign, __makeTemplateObject, __rest } from "tslib";
import React from 'react';
import { css } from 'styled-components';
import Flex from '../Flex';
import { createComponent } from '../utils';
var getMargin = function (p) {
    if (p.collapse) {
        return 0;
    }
    return typeof p.gutter === 'number' ? p.gutter / 2 : p.theme.gridGutter / 2;
};
var StyledRow = createComponent({
    name: 'Row',
    as: Flex,
    style: function (_a) {
        var vertical = _a.vertical, reverse = _a.reverse;
        var direction = vertical ? 'column' : 'row';
        return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      flex: 0 1 auto;\n      flex-direction: ", ";\n      flex-wrap: wrap;\n      margin-right: -", "px;\n      margin-left: -", "px;\n    "], ["\n      flex: 0 1 auto;\n      flex-direction: ", ";\n      flex-wrap: wrap;\n      margin-right: -", "px;\n      margin-left: -", "px;\n    "])), reverse ? direction + "-reverse" : direction, getMargin, getMargin);
    },
});
export var Row = function (_a) {
    var children = _a.children, gutter = _a.gutter, reverse = _a.reverse, collapse = _a.collapse, vertical = _a.vertical, props = __rest(_a, ["children", "gutter", "reverse", "collapse", "vertical"]);
    return (React.createElement(StyledRow, __assign({}, props, { gutter: gutter, reverse: reverse, collapse: collapse, vertical: vertical }), React.Children.map(children, function (child) {
        if (React.isValidElement(child)) {
            return React.cloneElement(child, { gutter: gutter, collapse: collapse, vertical: vertical });
        }
        return child;
    })));
};
Row.displayName = 'Row';
Row.defaultProps = {
    vertical: false,
    reverse: false,
    collapse: false,
};
var templateObject_1;
//# sourceMappingURL=Row.js.map